// Compatibility marker for call sites that still gate their query on the old
// browser token. This is deliberately not a credential: the proxy obtains and
// injects the real OAuth token for every upstream request.
export const PROXY_MANAGED_AUTH = "proxy-managed";

const getStorageToken = () => PROXY_MANAGED_AUTH;

export { getStorageToken };
